import React from 'react';
import { Row, Col, Button, Alert, ControlLabel } from 'react-bootstrap';

export default class FittingRecordEditComponent extends React.Component {

    componentDidMount() {
    }

    render() {
        return (
            <div>
                <Row>
                    <Col xs={2} sm={2} md={2}>
                        <Button bsStyle="info" onClick={this.props.editFittingRecord}>儲存</Button>
                    </Col>
                    <Col xs={2} sm={2} md={2}>
                        <Button bsStyle="info" onClick={this.props.deleteFittingRecord}>清除套量資料</Button>
                    </Col>
                    <Col xs={8} sm={8} md={8}>
                        <Alert bsStyle={this.props.alertStyle}>
                            {this.props.alertMessage}
                        </Alert>
                    </Col>
                </Row>
                <Row>
                    <Col xs={4} sm={2} md={2}><ControlLabel>類別</ControlLabel><br />{this.props.orderer.get('displayName')}</Col>
                    <Col xs={7} sm={3} md={3}><ControlLabel>大隊</ControlLabel><br />{this.props.orderer.get('firefighterDivision')}</Col>
                    <Col xs={5} sm={3} md={3}><ControlLabel>分隊</ControlLabel><br />{this.props.orderer.get('firefighterSquadron')}</Col>
                    <Col xs={4} sm={2} md={2}><ControlLabel>職稱</ControlLabel><br />{this.props.orderer.get('firefighterTitle')}</Col>
                    <Col xs={4} sm={2} md={2}><ControlLabel>姓名</ControlLabel><br />{this.props.orderer.get('firefighterName')}</Col>
                </Row>
                <Row>
                    <Col xs={4} sm={2} md={2}><ControlLabel>狀態</ControlLabel>{this.props.fittingStatus}<br /><br /></Col>
                </Row>
                {this.props.fittingRows}
            </div>
        )
    }
};


// WEBPACK FOOTER //
// ./src/components/FittingRecordEditComponent.jsx